import { withDefault, StringParam } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SortDir,
  BaseellaStatus,
  SchemaFilterType,
  BaseellaStatusTitle,
} from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: 'Transaction identifier',
    hidden: true,
    sortable: true,
  },
  {
    name: 'transferDate',
    label: 'Transfer Date',
    sortable: true,
  },
  {
    name: 'currencyId',
    label: 'Currency',
    sortable: true,
  },
  {
    name: 'baseellaStatus',
    label: 'Status',
    sortable: true,
  },
  {
    name: 'sum',
    label: 'Amount',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'senderAccountNumber',
    label: 'Sender Account',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'recipientAccountNumber',
    label: 'Recipient Account',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'paymentType',
    label: 'Payment type',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'acceptedOut',
    label: 'Accept out date',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'acceptedIn',
    label: 'Accept in date',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'documentNumber',
    label: 'Document number',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'info',
    label: 'Payment details',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'deletedAt',
    label: '',
    hidden: true,
  },
  {
    name: 'values',
    label: '',
    hidden: true,
  },
];

export const columnsLabels = {
  transferDate: 'Date created',
  transferDateFrom: 'Date created From',
  transferDateTo: 'Date created To',
  currencyId: 'Currency',
  baseellaStatus: 'Status',
  acceptedOut: 'Accept out date',
  recipientAccountNumber: 'Recipient Account',
  acceptedIn: 'Accept in date',
  senderAccountNumber: 'Sender Account',
  paymentType: 'Payment type',
  id: 'Transaction identifier',
  documentNumber: 'Document number',
  info: 'Payment details',
};

export const expandableColumns = [
  {
    name: 'transferDate',
    label: 'Date',
  },
  {
    name: 'currencyId',
    label: 'Currency',
  },
  {
    name: 'status',
    label: 'Status',
  },
  {
    name: 'sum',
    label: 'Amount',
  },
  {
    name: 'debitAccountId',
    label: 'Debit account No.',
  },
  {
    name: 'debitAccount',
    label: 'Debit account description',
  },
  {
    name: 'creditAccountId',
    label: 'Credit account No.',
  },
  {
    name: 'creditAccount',
    label: 'Credit account description',
  },
  {
    name: 'documentNumber',
    label: 'Doc. N',
  },
];

export const defaultSorter = {
  sortProp: columns[1].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  transferDate: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['transferDateFrom', 'transferDateTo'],
  },
  transferDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  transferDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  // acceptedIn: {
  //   value: CustomStringParam,
  //   type: SchemaFilterType.DATE,
  // },
  // acceptedOut: {
  //   value: CustomStringParam,
  //   type: SchemaFilterType.DATE,
  // },
  currencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  documentNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  baseellaStatus: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  id: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  info: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  senderAccountNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  recipientAccountNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  paymentType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'transferDate',
    type: FilterType.DATE_RANGE,
    pickerType: 'twoPickers',
  },
  // {
  //   name: 'acceptedIn',
  //   type: FilterType.DATE,
  //   pickerType: 'twoPickers',
  // },
  // {
  //   name: 'acceptedOut',
  //   type: FilterType.DATE,
  //   pickerType: 'twoPickers',
  // },
  {
    name: 'currencyId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter currency...',
  },
  {
    name: 'paymentType',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter payment type...',
  },
  {
    name: 'senderAccountNumber',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
  {
    name: 'recipientAccountNumber',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
  {
    name: 'info',
    type: FilterType.TEXT,
    placeholder: 'Enter payment details...',
  },
  {
    name: 'baseellaStatus',
    type: FilterType.CHECKBOX,
    withClearButton: true,
    fields: [
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.DRAFT,
        value: BaseellaStatus.DRAFT,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.NONE,
        value: BaseellaStatus.NONE,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.UNDEFINED_FUNDS,
        value: BaseellaStatus.UNDEFINED_FUNDS,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.NEW,
        value: BaseellaStatus.NEW,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.HELD,
        value: BaseellaStatus.HELD,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.SENT,
        value: BaseellaStatus.SENT,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.PROC,
        value: BaseellaStatus.PROC,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.ARCH,
        value: BaseellaStatus.ARCH,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.REV,
        value: BaseellaStatus.REV,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML,
        value: BaseellaStatus.AML,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML_INFO,
        value: BaseellaStatus.AML_INFO,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML_REJ,
        value: BaseellaStatus.AML_REJ,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML_DONE,
        value: BaseellaStatus.AML_DONE,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.REJECTED,
        value: BaseellaStatus.REJECTED,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.NOT_SIGNED,
        value: BaseellaStatus.NOT_SIGNED,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.READY_TO_SEND,
        value: BaseellaStatus.READY_TO_SEND,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.READY_TO_PSP,
        value: BaseellaStatus.READY_TO_PSP,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.ACCP_OUT,
        value: BaseellaStatus.ACCP_OUT,
      },
    ],
  },
  {
    name: 'id',
    type: FilterType.TEXT,
    placeholder: 'Enter identifier...',
  },
  {
    name: 'documentNumber',
    type: FilterType.TEXT,
    placeholder: 'Enter document number...',
  },
];
